{
  "app": {
    "title": "WStudio Reporting Admin",
    "shellTitle": "WSR Product Admin · Platform Console",
    "loading": "Loading"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "remove": "Remove",
    "create": "Create",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "retry": "Retry",
    "search": "Search",
    "filter": "Filter",
    "clear": "Clear",
    "reset": "Reset",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "copy": "Copy",
    "copied": "Copied",
    "loading": "Loading",
    "actions": "Actions",
    "optional": "Optional",
    "more": "More",
    "menu": "Menu",
    "language": "Language",
    "unmapped": "Unmapped",
    "comingSoon": "Coming soon",
    "noProgress": "No progress"
  },
  "help": {
    "ariaLabel": "Help for {{label}}",
    "scope": {
      "platform": "Platform",
      "platformDefault": "Platform default",
      "tenantOverride": "Tenant override",
      "endpoint": "Endpoint",
      "allJobs": "All jobs",
      "genesisPacing": "Genesis pacing",
      "outboundRate": "Outbound rate",
      "attendanceOnly": "Attendance only"
    }
  },
  "language_switcher": {
    "label": "Language",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "home": "Home",
    "tenants": "Tenants",
    "globalSettings": "Global Settings",
    "ingestionJobs": "Ingestion Jobs",
    "platformSection": "PLATFORM",
    "signOut": "Sign out",
    "signIn": "Sign in",
    "group": {
      "operations": "Operations",
      "configuration": "Configuration"
    },
    "dashboard": "Dashboard",
    "queue": "Queue",
    "notifications": "Notifications",
    "engine": "Engine",
    "globalConfig": "Global config"
  },
  "shell": {
    "globalStatus": "Global",
    "globalEnabled": "Enabled",
    "globalDisabled": "Disabled",
    "globalUnknown": "–",
    "globalStatusLabel": "Global ingestion status",
    "scope": "Platform — all tenants",
    "notificationsAriaLabel": "Notifications",
    "role": {
      "productAdmin": "Product admin"
    }
  },
  "page": {
    "dashboard": { "title": "Dashboard", "subtitle": "Fleet health at a glance." },
    "queue": {
      "title": "Queue",
      "subtitle": "Ingestion queue depth, activity and upcoming work."
    },
    "notifications": { "title": "Notifications", "subtitle": "Alerts and system notifications." },
    "tenants": { "title": "Tenants", "subtitle": "Tenant roster and configuration." },
    "engine": { "title": "Engine", "subtitle": "Engine and schedule configuration." },
    "globalConfig": {
      "title": "Global WStudio config",
      "subtitle": "Shared endpoint paths and parameters used by every tenant."
    }
  },
  "jobType": {
    "USER_SYNC": "User Sync",
    "SALES_SYNC": "Sales Sync",
    "ATTENDANCE_SYNC": "Attendance Sync",
    "REPORT_USER_SYNC_SUMMARY": "User Sync Summary",
    "GHL_FIELD_CHECK": "GHL Field Check",
    "PRODUCT_SYNC": "Product Sync",
    "SALES_RECONCILE": "Sales Reconcile"
  },
  "jobTypeHelp": {
    "SALES_RECONCILE": "Re-walks sales history to catch later edits. A run that updates nothing is a healthy run."
  },
  "notifType": {
    "CREDENTIAL_INVALID": {
      "label": "Credential invalid",
      "title": "Credential invalid",
      "body": "The {{integration}} credential for {{jobType}} is invalid or expired."
    },
    "INGESTION_JOB_FAILURE": {
      "label": "Ingestion job failure",
      "title": "Ingestion job failure",
      "body": "{{jobType}} failed. Latest error: {{latestError}}"
    },
    "QUEUE_DEPTH_HIGH": {
      "label": "Queue depth high",
      "title": "Queue depth high",
      "body": "{{pending}} jobs are pending in the queue."
    },
    "USER_SYNC_NOT_CONFIGURED": {
      "label": "User sync not configured",
      "title": "User sync not configured",
      "body": "{{jobType}} is not configured: {{reason}}"
    },
    "USER_SYNC_EVENT_WRITE_FAILED": {
      "label": "User sync event write failed",
      "title": "User sync event write failed",
      "body": "Could not write the user sync event: {{reason}}"
    },
    "SALES_SYNC_NOT_CONFIGURED": {
      "label": "Sales sync not configured",
      "title": "Sales sync not configured",
      "body": "{{jobType}} is not configured: {{reason}}"
    },
    "ATTENDANCE_SYNC_NOT_CONFIGURED": {
      "label": "Attendance sync not configured",
      "title": "Attendance sync not configured",
      "body": "{{jobType}} is not configured: {{reason}}"
    },
    "INGESTION_BREAKER_TRIPPED": {
      "label": "Sync disabled — repeated failures",
      "title": "Sync disabled — repeated failures",
      "body": "{{jobType}} failed on {{failureDays}} separate days ({{failures}} failed runs) within {{windowHours}}h — more than the {{maxFailures}} tolerated — so the service was switched off. Fix the cause, then re-enable the service. Latest error: {{latestError}}"
    }
  },
  "jobStatus": {
    "PENDING": "Pending",
    "CLAIMED": "Claimed",
    "RUNNING": "Running",
    "SUCCEEDED": "Succeeded",
    "FAILED": "Failed",
    "SKIPPED": "Skipped"
  },
  "severity": {
    "INFO": "Info",
    "WARN": "Warning",
    "ERROR": "Error"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "auth": {
    "redirecting": "Redirecting to sign in…",
    "returning": "Completing sign-in…",
    "noAccessTitle": "You don't have access to this console",
    "noAccessBody": "Your account is signed in but has not been granted access to this product admin console. Contact your administrator if you believe this is a mistake.",
    "productAdminRequired": "Product admin access required",
    "productAdminRequiredBody": "You're signed in, but your account hasn't been granted access to this product admin console.",
    "signedOutTitle": "You're signed out",
    "signedOutBody": "Your platform-admin session has ended.",
    "signInAgain": "Sign in again",
    "errorTitle": "Sign-in could not be completed",
    "errorBody": "Your session could not be restored. Try signing in again.",
    "tryAgain": "Try again"
  },
  "operator": {
    "menuTitle": "Account",
    "platformAdminRequired": "Platform admin required",
    "platformAdminRequiredBody": "You don't have permission to view this. A ROLE_PLATFORM_ADMIN claim is required.",
    "role": {
      "SAAS_ADMIN": "Platform Admin",
      "SUPER_ADMIN": "Super Admin"
    }
  },
  "tenants": {
    "title": "Tenants",
    "subline": "{{discovered}} discovered · {{active}} active · cross-tenant roster",
    "searchLabel": "Search tenants",
    "searchPlaceholder": "Search tenant or slug",
    "tableAriaLabel": "Tenants roster",
    "col": {
      "tenant": "Tenant",
      "status": "Status",
      "wstudio": "wStudio",
      "enabled": "Enabled",
      "enables": "Enables",
      "services": "Services",
      "lastSync": "Last sync",
      "progress": "Progress"
    },
    "tabs": {
      "all": "All",
      "active": "Active",
      "paused": "Paused",
      "needsAttention": "Needs attention"
    },
    "enables": {
      "global": "Global",
      "tenant": "Tenant",
      "on": "On",
      "off": "Off",
      "onNotRunning": "On, but not running"
    },
    "detail": {
      "wstudioNotConfigured": "WStudio credentials not configured for this tenant.",
      "servicesTitle": "Services",
      "effectiveLabel": "Effective: {{state}}"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "suspended": "Suspended"
    },
    "wstudio": {
      "configured": "Configured",
      "notConfigured": "Not configured"
    },
    "enabled": {
      "true": "Enabled",
      "false": "Disabled"
    },
    "lastSync": {
      "never": "—",
      "justNow": "Just now",
      "minutesAgo": "{{n}} min ago",
      "hoursAgo": "{{n}} hr ago",
      "daysAgo": "{{n}} d ago"
    },
    "backfill": {
      "complete": "✓",
      "neverStarted": "—",
      "through": "through {{date}}",
      "phase": {
        "BACKFILL": "Backfill",
        "INCREMENTAL": "Incremental"
      },
      "abbr": {
        "userSync": "US",
        "salesSync": "SS",
        "attendanceSync": "AT",
        "reportSummary": "RS"
      }
    },
    "service": {
      "userSync": "User Sync",
      "salesSync": "Sales Sync",
      "attendanceSync": "Attendance Sync",
      "reportSummary": "Report Summary",
      "on": "On",
      "off": "Off"
    },
    "emptyTitle": "No tenants",
    "emptyBody": "No tenants found.",
    "emptySearch": "No tenants match your search.",
    "emptyStatus": "No tenants on this page match the selected filters.",
    "loadError": "Could not load tenants.",
    "opsLoadError": "Operational details could not be loaded.",
    "opsNotProvisioned": "Ops not provisioned",
    "statusFilter": {
      "label": "Status",
      "all": "All",
      "active": "Active",
      "suspended": "Suspended"
    },
    "actionFilter": {
      "label": "Needs attention",
      "pageOnly": "Filtering the tenants loaded on this page."
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {{page}} of {{total}}"
    },
    "createButton": "Create tenant",
    "create": {
      "title": "Create tenant",
      "slugLabel": "Slug",
      "slugHelper": "Lowercase letters, numbers, hyphens — up to 63 characters.",
      "slugRequired": "Slug is required.",
      "slugInvalid": "Slug must be a valid DNS label (lowercase letters, numbers, hyphens; up to 63 characters).",
      "nameLabel": "Name",
      "nameRequired": "Name is required.",
      "nameTooLong": "Name must be 200 characters or fewer.",
      "signupModeLabel": "Signup mode",
      "submitButton": "Create",
      "submitting": "Creating…",
      "cancelButton": "Cancel",
      "errorReservedSlug": "That slug is reserved. Choose a different one.",
      "errorDuplicateSlug": "That slug is already registered. Choose a different one.",
      "errorGeneric": "Could not create tenant. Please try again.",
      "errorOutcomeUnknown": "We couldn't confirm whether the tenant was created. The tenant list has been refreshed — check it for “{{slug}}” before trying again.",
      "longRunningHint": "Creating a tenant can take up to 30 seconds.",
      "success": "Tenant “{{name}}” created."
    },
    "signupMode": {
      "PUBLIC": "Public",
      "INVITE_ONLY": "Invite only",
      "ADMIN_CREATED_ONLY": "Admin-created only",
      "DISABLED": "Disabled"
    }
  },
  "queue": {
    "kpi": {
      "pending": "Pending",
      "inFlight": "In flight",
      "oldestPending": "Oldest pending",
      "failedLast24h": "Failed (24h)"
    },
    "filters": {
      "tenantLabel": "Tenant",
      "allTenants": "All tenants",
      "pollNote": "Live — updates every ~5s",
      "searchLabel": "Filter jobs",
      "searchPlaceholder": "Tenant, job type, status…"
    },
    "col": {
      "id": "ID",
      "tenant": "Tenant",
      "jobType": "Job type",
      "kind": "Kind",
      "status": "Status",
      "timing": "Timing",
      "progress": "Progress"
    },
    "kind": {
      "GENESIS": "genesis",
      "BACKFILL": "backfill",
      "LEADING_EDGE": "leading edge",
      "INCREMENTAL": "incremental"
    },
    "rowsProcessed": "{{n}} rows",
    "upcoming": {
      "title": "Upcoming",
      "overdueTitle": "Overdue",
      "overdueBy": "{{duration}} overdue",
      "colTenant": "Tenant",
      "colJob": "Job",
      "colNext": "Next",
      "in": "in {{duration}}",
      "dueNow": "due now",
      "empty": "Nothing scheduled."
    },
    "card": {
      "running": "Running {{duration}}",
      "finishedAgo": "Finished {{duration}} ago",
      "scheduledFor": "Scheduled {{time}}"
    },
    "tableAriaLabel": "Queue jobs",
    "empty": "No active jobs.",
    "emptyFiltered": "No jobs match the current filters.",
    "loadError": "Could not load the queue."
  },
  "notifications": {
    "filters": {
      "severityLabel": "Severity",
      "allSeverities": "All severities",
      "tenantLabel": "Tenant",
      "allTenants": "All tenants",
      "platformOption": "Platform (*)",
      "tabsAriaLabel": "Filter by status"
    },
    "tabs": {
      "all": "All",
      "open": "Open",
      "acknowledged": "Acknowledged",
      "resolved": "Resolved"
    },
    "status": {
      "OPEN": "Open",
      "ACKNOWLEDGED": "Acknowledged",
      "RESOLVED": "Resolved"
    },
    "meta": {
      "occurrences": "{{n}}× seen",
      "lastSeen": "Last seen {{time}}"
    },
    "remedy": {
      "credentialInvalid": "Re-authenticate the {{integration}} credential in saas-auth, then re-enable {{jobType}}."
    },
    "actions": {
      "acknowledge": "Acknowledge",
      "openTenant": "Open tenant"
    },
    "ackError": "Could not acknowledge this notification. Please try again.",
    "listAriaLabel": "Notifications",
    "empty": "No notifications.",
    "emptyFiltered": "No notifications match the current filters.",
    "loadError": "Could not load notifications.",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "pageIndicator": "Page {{page}} of {{total}}"
  },
  "dashboard": {
    "kpiRow": {
      "ariaLabel": "Fleet KPIs"
    },
    "kpi": {
      "enabledTenants": "Enabled tenants",
      "enabledTenantsValue": "{{enabled}} of {{total}}"
    },
    "depthTable": {
      "title": "Depth by job type",
      "ariaLabel": "Queue depth by job type",
      "col": {
        "jobType": "Job type",
        "pending": "Pending",
        "running": "Running",
        "succeeded": "Succeeded",
        "failed": "Failed"
      },
      "empty": "No job-type data yet.",
      "loadError": "Could not load queue depth."
    },
    "engineState": {
      "title": "Engine state",
      "manageLink": "Manage in Engine",
      "loadError": "Could not load engine state."
    },
    "needsAttention": {
      "title": "Needs attention",
      "viewAll": "View all notifications",
      "empty": "No open notifications.",
      "loadError": "Could not load notifications."
    }
  },
  "globalConfig": {
    "formAriaLabel": "Global WStudio configuration form",
    "loadError": "Could not load the global WStudio configuration.",
    "saveError": "Could not save the global WStudio configuration.",
    "saveSuccess": "Global WStudio configuration saved.",
    "save": "Save configuration",
    "saveAll": "Save all settings",
    "saving": "Saving…",
    "tabs": {
      "ariaLabel": "Global WStudio configuration sections",
      "enable": "Enable",
      "attendance": "Attendance",
      "other": "Additional"
    },
    "notes": {
      "silentFailure": "Endpoint values are sent to WStudio as written. A wrong value usually returns no data rather than an error — verify with the dry-run tests after any change.",
      "invalidatesVerification": "Saving a change bumps the config generation, marking every tenant's dry-run results stale. Affected tenants stop dispatching until their dry runs are re-run."
    },
    "validation": {
      "path": "Enter a path beginning with /. A fixed query is allowed."
    },
    "active": {
      "label": "WStudio enabled",
      "help": "Controls whether the shared WStudio configuration is active."
    },
    "groups": {
      "userList": {
        "title": "User list",
        "help": "Endpoint path and request parameters for the WStudio user list."
      },
      "sales": {
        "title": "Sales",
        "help": "Endpoint paths and request parameters for tenant and per-user sales."
      },
      "report": {
        "title": "Report",
        "help": "Endpoint path for the attendance report."
      },
      "other": {
        "title": "Additional settings",
        "help": "Additional global keys returned by wsr-api."
      }
    },
    "fields": {
      "unknownHelp": "Global value supplied by wsr-api.",
      "WStudio_user_listWithFilters": {
        "label": "User list path",
        "help": "Path after the tenant domain. A fixed query string is allowed.",
        "detail": "Path to the WStudio user list, appended to each tenant's domain. Supplies every member the platform knows about. It may carry a fixed query string; `filter` and `filters` are appended by the engine (see below)."
      },
      "WStudio_user_listWithFilters_max": {
        "label": "User list maximum",
        "help": "Maximum users requested per page.",
        "detail": "Members fetched per request. The engine pages until the roster is exhausted, so this controls request size, not how many members are synced."
      },
      "WStudio_user_listWithFilters_offset": {
        "label": "User list offset",
        "help": "Starting offset for user-list requests.",
        "detail": "Starting position for the first page. Leave at zero; a non-zero value skips members permanently."
      },
      "WStudio_user_listWithFilters_filter": {
        "label": "Search term",
        "help": "Optional filter sent with user-list requests.",
        "detail": "WStudio's free-text search term. Normally empty, and it must still be sent when empty — the endpoint returns nothing if the parameter is absent entirely. Leave blank unless you deliberately want to restrict the roster to matching names."
      },
      "WStudio_user_listWithFilters_filters": {
        "label": "Roster criteria",
        "detail": "WStudio's JSON criteria object — which members the roster includes (active, blocked, archived, employees, admins). Distinct from `filter` above despite the near-identical name. Stored as plain JSON; the engine handles the encoding, so do not paste a URL-encoded value."
      },
      "WStudio_sales_listSales": {
        "label": "Tenant sales path",
        "help": "Path after the tenant domain for tenant-wide sales.",
        "detail": "Path to the tenant-wide sales feed — the source for the sales warehouse and all revenue reporting. Its query string carries `includeDeleted` and a required empty `filter=`; removing either changes what comes back, and omitting `filter=` returns nothing at all."
      },
      "WStudio_sales_listForUser": {
        "label": "Per-user sales path",
        "help": "Path after the tenant domain for per-user sales.",
        "detail": "Path to a single member's entitlement history. Used for per-member enrichment rather than bulk reporting; not the source of the sales warehouse."
      },
      "WStudio_sales_listForUser_max": {
        "label": "Per-user sales maximum",
        "help": "Maximum sales requested per user.",
        "detail": "Page size and starting position for a single member's entitlement history. The same rules apply: offset should stay at zero."
      },
      "WStudio_sales_listForUser_offset": {
        "label": "Per-user sales offset",
        "help": "Starting offset for per-user sales requests.",
        "detail": "Page size and starting position for a single member's entitlement history. The same rules apply: offset should stay at zero."
      },
      "WStudio_sales_listForUser_forceUpdate": {
        "label": "Force update",
        "help": "Value sent as the per-user sales force-update parameter.",
        "detail": "When set, the per-member enrichment refreshes on every sync rather than only when a member's expiry date changed. Costs one extra WStudio request per member per run; leave off unless enrichment is visibly stale."
      },
      "WStudio_report_checkin": {
        "label": "Attendance report path",
        "help": "Path after the tenant domain for the attendance report.",
        "detail": "Path to the attendance report generator. Returns a link to a generated spreadsheet, which the engine then downloads and parses — a two-step call, so a change here affects both steps."
      },
      "WStudio_product_listByType": {
        "detail": "Path to the product catalogue, queried once per product type (below). The catalogue is what lets a sale be classified as a membership, a class pack or personal training."
      },
      "WStudio_product_listByType_max": {
        "detail": "Page size and starting position for the product catalogue. Catalogues are small; the defaults are rarely worth changing."
      },
      "WStudio_product_listByType_offset": {
        "detail": "Page size and starting position for the product catalogue. Catalogues are small; the defaults are rarely worth changing."
      },
      "WStudio_product_types": {
        "detail": "Comma-separated list of product types to fetch, e.g. `byTime`. The catalogue is queried once per type, so adding a type adds a request per tenant per run. Types not listed here are never fetched, and a sale referencing one will not be classifiable."
      },
      "WStudio_membership_gracePeriodDays": {
        "detail": "How long after a membership expires a member still counts as active, in a grace state, before being treated as lapsed. Set it to match how long you would still call someone a member after a missed payment."
      },
      "WStudio_membership_shortTermThresholdDays": {
        "detail": "The duration below which a purchase counts as short-term rather than a membership. A one-week pass falls below it; a monthly membership does not. This decides whether a buyer is tagged as a member or a casual visitor."
      },
      "WStudio_membership_renewalDueSoonDays": {
        "detail": "How many days before expiry a member is flagged as due for renewal, so marketing can act before they lapse rather than after."
      },
      "WStudio_membership_tenureEstablishedDays": {
        "detail": "How long since a member's first purchase before they stop being \"new\". Below this they are new; above it, established."
      },
      "WStudio_membership_tenureLoyalDays": {
        "detail": "How long since a member's first purchase before they count as loyal. Must be larger than the established threshold."
      },
      "WStudio_membership_productFamilyByCategory": {
        "detail": "Maps your WStudio product categories to the three families the platform understands — membership, class, and personal training — as comma-separated `category:family` pairs. A malformed entry is skipped silently, so a typo means that category simply never maps; check the result after editing rather than assuming it took."
      },
      "WStudio_membership_valueMidThreshold": {
        "detail": "Lifetime spend boundaries separating low, mid and high value members. Amounts are in the currency the member's own sales are in, not converted — a member whose purchases span two currencies is left unbanded rather than being given a misleading total. Both must be set or no value band is produced at all."
      },
      "WStudio_membership_valueHighThreshold": {
        "detail": "Lifetime spend boundaries separating low, mid and high value members. Amounts are in the currency the member's own sales are in, not converted — a member whose purchases span two currencies is left unbanded rather than being given a misleading total. Both must be set or no value band is produced at all."
      },
      "WStudio_genesis_syncReadyCoverageDays": {
        "detail": "How much attendance history must be loaded before a tenant starts syncing to GoHighLevel. This is the gate that decides when a newly-enabled tenant goes live, and until it is met nothing reaches the CRM — which is correct, since engagement signals computed from partial history would be wrong. Lower it to go live sooner with shallower history; raise it to be more conservative."
      },
      "GhlFieldMappings_CONTACT_PREFIX": {
        "detail": "The key prefix identifying which settings map WStudio member fields onto GoHighLevel contact fields. Structural rather than a value you tune; changing it orphans every existing mapping."
      }
    }
  },
  "global": {
    "title": "Global Settings",
    "subtitle": "Platform-wide controls. Changes apply to every tenant.",
    "enableSection": "Global ingestion",
    "enableDescription": "When off, the scheduler enqueues nothing for any tenant. Discovery still runs while this is off.",
    "enableLabel": "Enable global ingestion",
    "toggleEnabled": "Enabled",
    "toggleDisabled": "Disabled",
    "toggleUnknown": "Unknown",
    "toggleSuccessOn": "Global ingestion enabled.",
    "toggleSuccessOff": "Global ingestion disabled.",
    "toggleError": "Could not update global setting. Please try again.",
    "discoverySection": "Roster discovery",
    "discoveryDescription": "Runs the saas-auth reconciliation sweep on demand — the same sweep that runs hourly in the background. New tenants materialize dormant and disabled. Tenants that left the roster are flagged, not deleted.",
    "discoveryButton": "Run discovery now",
    "discoveryRunning": "Running discovery…",
    "discoveryError": "Discovery failed. Please try again.",
    "discoveryResultTitle": "Discovery complete",
    "discoveryResultSeen": "Seen",
    "discoveryResultCreated": "Created",
    "discoveryResultStatusUpdated": "Status updated",
    "discoveryResultLeaversFlagged": "Leavers flagged",
    "statsSection": "Fleet counts",
    "statTotal": "Total tenants",
    "statActive": "Active",
    "statActiveNote": "(status = active)",
    "statWstudio": "wStudio configured",
    "loadError": "Could not load fleet counts."
  },
  "engine": {
    "loadError": "Could not load engine configuration.",
    "formAriaLabel": "Engine configuration form",
    "restartRequired": "Restart required",
    "unit": {
      "seconds": "seconds",
      "count": "count"
    },
    "validation": {
      "secondsMin1": "Must be an integer ≥ 1.",
      "countMin0": "Must be an integer ≥ 0.",
      "countMin1": "Must be an integer ≥ 1.",
      "isolationInvalid": "Must be one of the 5 supported isolation levels.",
      "invariant": "heartbeatIntervalSeconds must be less than leaseTtlSeconds, which must be less than maxExecutionTimeSeconds.",
      "invariantHint": "Part of the heartbeat/lease/max-execution invariant."
    },
    "save": {
      "success": "Configuration saved.",
      "error": "Could not save configuration. Please try again.",
      "changedCount": "{{count}} changed",
      "noChanges": "No changes",
      "revert": "Revert",
      "save": "Save",
      "saveAll": "Save all settings",
      "saving": "Saving…"
    },
    "tabs": {
      "ariaLabel": "Engine settings sections"
    },
    "group": {
      "cadence": "Cadences",
      "retention": "Retention",
      "tuning": "Tuning"
    },
    "flags": {
      "title": "Start / stop",
      "globalReadOnly": "Global (read-only — see Tenants)",
      "toggleError": "Could not update. Please try again.",
      "engineEnabled": "Engine",
      "engineEnabledDescription": "The dispatcher/claimer/heartbeat/reaper loop that runs jobs.",
      "discoveryEnabled": "Discovery",
      "discoveryEnabledDescription": "The saas-auth tenant-roster reconciliation sweep.",
      "pruneEnabled": "Prune",
      "pruneEnabledDescription": "Terminal-job and event retention cleanup.",
      "orphanSweepEnabled": "Orphan sweep",
      "orphanSweepEnabledDescription": "Deletes leftover temporary files from the attendance pipeline, which downloads a generated spreadsheet to disk and normally removes it immediately. This sweep is the backstop for a process killed mid-download. It does not touch jobs or data."
    },
    "fields": {
      "engineEnabled": {
        "detail": "The master switch for the ingestion loop: dispatcher, claimer, heartbeat and reaper. Turning it off is a graceful pause — running jobs finish, nothing new is enqueued or claimed, and no data is lost. Use it to quiet the platform during maintenance rather than disabling tenants one by one."
      },
      "discoveryEnabled": {
        "detail": "The sweep that reconciles the tenant roster against saas-auth, so tenants added or removed there appear here without manual entry. Turning it off freezes the roster; existing tenants keep syncing normally."
      },
      "pruneEnabled": {
        "detail": "Housekeeping that deletes terminal job rows and audit events older than the retention windows below. Turning it off keeps history indefinitely and the tables grow without bound."
      },
      "orphanSweepEnabled": {
        "detail": "Deletes leftover temporary files from the attendance pipeline, which downloads a generated spreadsheet to disk and normally removes it immediately. This sweep is the backstop for a process killed mid-download. It does not touch jobs or data."
      },
      "dispatcherIntervalSeconds": {
        "detail": "How often the engine checks which jobs are due and enqueues them. This is a floor on everything else: a job scheduled to repeat every minute still only starts when the dispatcher ticks. At 900s (15m) an attendance backfill window advances at most four times an hour; at 60s it advances up to once a minute. Lower is inexpensive — the check is a single query."
      },
      "claimerIntervalSeconds": {
        "detail": "How often workers look for enqueued work to pick up. This is a poll of already-created rows, so it controls pickup latency, not how much work exists. The default of 5s is rarely worth changing."
      },
      "heartbeatIntervalSeconds": {
        "detail": "How often a running job reports that it is still alive, extending its lease. It must stay comfortably below the lease TTL or a healthy long-running job — a genesis walk or a large attendance window — will be reclaimed as if it had died."
      },
      "reaperIntervalSeconds": {
        "detail": "How often the engine looks for jobs whose lease has expired or which have exceeded the maximum execution time, and returns them to the queue. This is what recovers work after a crash or a deploy that restarted the application mid-run."
      },
      "terminalCleanupIntervalSeconds": {
        "detail": "How often finished job rows past the terminal retention window are deleted. Purely housekeeping; it never touches running or pending work."
      },
      "discoveryIntervalSeconds": {
        "detail": "How often the tenant roster is reconciled against saas-auth. Hourly is ample — a new tenant appears within one interval of being created upstream."
      },
      "pruneIntervalSeconds": {
        "detail": "How often the retention cleanup runs. Infrequent is fine; this is a bulk delete, so running it rarely and cheaply beats running it constantly."
      },
      "orphanSweepIntervalSeconds": {
        "detail": "How often leftover attendance temporary files are checked for. Only files older than the orphan sweep age are removed, so this can run infrequently without risk."
      },
      "terminalRetentionSeconds": {
        "detail": "How long finished job rows are kept before pruning. This is your job history: at the default of 14 days you can investigate a failure from last week, but not last month. Raising it costs table size, not performance."
      },
      "eventRetentionSeconds": {
        "detail": "How long audit and activity events are kept. Longer than job retention by design — events are the record of what changed and who changed it, which stays useful long after the job row that produced it stops mattering."
      },
      "orphanSweepAgeSeconds": {
        "detail": "How old a temporary file must be before the sweep removes it. It must exceed the longest realistic attendance download, or the sweep could delete a file a running job is still using. The default of 6 hours is deliberately generous."
      },
      "defaultFrequencySeconds": {
        "detail": "The repeat interval used by any job type that does not define its own schedule. Job types with real schedules — the daily syncs, the reconciliation sweep, backfill cooldowns — ignore this entirely."
      },
      "leaseTtlSeconds": {
        "detail": "How long a claimed job is considered alive without a heartbeat before the reaper may reclaim it. Set it several times the heartbeat interval; too tight and healthy long-running jobs get reclaimed mid-run and repeat work."
      },
      "maxExecutionTimeSeconds": {
        "detail": "The absolute ceiling on a single run, regardless of heartbeats. A job past this is treated as hung and terminated rather than retried forever. It must exceed your slowest legitimate run — a large attendance window or a long genesis page walk."
      },
      "retryBackoffBaseSeconds": {
        "detail": "The starting wait before a failed job is retried. Each further failure waits longer, up to the cap below, so a transient outage does not become a tight retry loop against a struggling upstream."
      },
      "retryBackoffCapSeconds": {
        "detail": "The longest the retry wait can grow to. This bounds how stale data can get during a sustained outage: at 1 hour, a tenant retries at least hourly no matter how long WStudio has been unavailable."
      },
      "ratePerTenantPeriodSeconds": {
        "detail": "The time window that the per-tenant request permits are counted over. Together with the permits below it forms the rule \"at most N requests per tenant per period\" — the primary control over how hard the platform pushes any one WStudio studio."
      },
      "rateGlobalPeriodSeconds": {
        "detail": "The window for the platform-wide request ceiling. Only applies when the global permits below are greater than zero. Requires a restart."
      },
      "maxAttempts": {
        "detail": "How many times a failing job is retried before it is marked permanently failed and stops. Distinct from rescues below: attempts count the job failing, rescues count the worker dying."
      },
      "maxRescues": {
        "detail": "How many times a job may be recovered after its worker died — a crash or a deploy — before it is treated as poison and failed permanently. Counted separately from attempts so a job repeatedly interrupted by deploys is not charged with failures it did not cause."
      },
      "batchClaimSize": {
        "detail": "How many queued jobs a worker claims in one database round trip. Larger batches reduce query overhead when the queue is deep; smaller batches spread work more evenly. Rarely worth changing."
      },
      "perTenantInFlightCap": {
        "detail": "The maximum number of jobs that may run simultaneously for one tenant. At 1, that tenant's sales, attendance, product and user syncs run strictly one after another — the main reason a tenant loading history feels slow. Raising it to 3 lets an attendance backfill proceed alongside other work, while still preventing one tenant from consuming the whole worker pool."
      },
      "maxConcurrent": {
        "detail": "The total number of jobs running at once across every tenant. This is the platform-wide ceiling; the per-tenant cap above divides it fairly. With max concurrent 5 and a per-tenant cap of 3, a single busy tenant can never take more than three of the five slots. Requires a restart."
      },
      "failureAlertThreshold": {
        "detail": "How many consecutive failures of the same job for the same tenant are needed before an admin notification is raised. At 3, the first two failures are silent. Set it to 1 to be notified of every failure — useful while onboarding tenants or diagnosing a new integration."
      },
      "failureBreakerMaxFailures": {
        "detail": "How many separate days (studio time) a job may fail for a tenant — counted since its last successful run or re-enable, and only inside the breaker window — before that tenant's service is switched off. 0 switches it off on the first failed day. Distinct from the failure-alert threshold above, which only raises a notification."
      },
      "failureBreakerWindowHours": {
        "detail": "Only failures inside this many trailing hours count toward the breaker. 0 turns the breaker off: failures still raise alerts, but the service is never switched off."
      },
      "ratePerTenantPermits": {
        "detail": "How many WStudio requests are allowed per tenant within each rate period. This is the courtesy dial — the setting that limits how hard the platform hits any single studio, independent of how many jobs are running. Lower it if an upstream complains; raise it cautiously."
      },
      "rateGlobalPermits": {
        "detail": "A platform-wide ceiling across every tenant combined. Zero disables it, leaving only the per-tenant limit — the usual configuration, since studios are separate systems and one tenant's traffic does not burden another's. Requires a restart."
      },
      "skipLockedClaim": {
        "detail": "Lets workers skip rows another worker has already locked instead of waiting for them. Keep it on: with it off, workers queue behind each other for the same rows and throughput drops sharply. Turn it off only if the database does not support the feature."
      },
      "isolation": {
        "detail": "The transaction isolation level used when claiming jobs. `READ_COMMITTED` is the correct choice for this queue and should not be changed without a specific reason — stricter levels add lock contention with no benefit here. Requires a restart."
      }
    },
    "emphasis": {
      "dispatcherInterval": "This is a floor on everything else: a job scheduled to repeat every minute still only starts when the dispatcher ticks.",
      "inFlightCap": "At 1, that tenant's sales, attendance, product and user syncs run strictly one after another — the main reason a tenant loading history feels slow.",
      "failureBreakerMaxFailures": "Separate days (studio time) with a failed run, since the last successful run or re-enable, before the service is switched off. 0 = switch off on the first failed day.",
      "failureBreakerWindowHours": "Only failures inside this many hours count. 0 = breaker off (alerts only)."
    },
    "knob": {
      "dispatcherIntervalSeconds": "Dispatcher interval",
      "claimerIntervalSeconds": "Claimer interval",
      "heartbeatIntervalSeconds": "Heartbeat interval",
      "reaperIntervalSeconds": "Reaper interval",
      "terminalCleanupIntervalSeconds": "Terminal cleanup interval",
      "discoveryIntervalSeconds": "Discovery interval",
      "pruneIntervalSeconds": "Prune interval",
      "orphanSweepIntervalSeconds": "Orphan sweep interval",
      "terminalRetentionSeconds": "Terminal retention",
      "eventRetentionSeconds": "Event retention",
      "orphanSweepAgeSeconds": "Orphan sweep age",
      "defaultFrequencySeconds": "Default frequency",
      "leaseTtlSeconds": "Lease TTL",
      "maxExecutionTimeSeconds": "Max execution time",
      "retryBackoffBaseSeconds": "Retry backoff base",
      "retryBackoffCapSeconds": "Retry backoff cap",
      "ratePerTenantPeriodSeconds": "Rate limit period (per tenant)",
      "rateGlobalPeriodSeconds": "Rate limit period (global)",
      "maxAttempts": "Max attempts",
      "maxRescues": "Max rescues",
      "batchClaimSize": "Batch claim size",
      "perTenantInFlightCap": "In-flight cap (per tenant)",
      "maxConcurrent": "Max concurrent",
      "failureAlertThreshold": "Failure alert threshold",
      "failureBreakerMaxFailures": "Failure days tolerated",
      "failureBreakerWindowHours": "Breaker window (hours)",
      "ratePerTenantPermits": "Rate limit permits (per tenant)",
      "rateGlobalPermits": "Rate limit permits (global)",
      "skipLockedClaim": "Skip-locked claim",
      "isolation": "Transaction isolation"
    }
  },
  "jobs": {
    "tableAriaLabel": "Ingestion jobs",
    "empty": "No jobs recorded.",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "pageIndicator": "Page {{page}} of {{total}}",
    "col": {
      "job": "Job",
      "status": "Status",
      "type": "Type",
      "tenant": "Tenant",
      "started": "Started",
      "duration": "Duration",
      "records": "Records",
      "actions": "Actions"
    },
    "status": {
      "queued": "Queued",
      "running": "Running",
      "success": "Success",
      "failed": "Failed",
      "skipped": "Skipped"
    },
    "chip": {
      "statusAriaLabel": "Status: {{label}}"
    },
    "actions": {
      "cancel": "Cancel",
      "cancelNotSupported": "Cancel not yet supported",
      "cancelAriaLabel": "Cancel job {{id}}"
    }
  },
  "ingestionJobs": {
    "title": "Ingestion Jobs",
    "filtersAriaLabel": "Job filters",
    "filterStatus": "Status",
    "filterType": "Type",
    "filterTenant": "Tenant",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "allTenants": "All tenants",
    "typeUserSync": "User Sync",
    "typeSalesSync": "Sales Sync",
    "typeAttendanceSync": "Attendance Sync",
    "typeReportSummary": "User Sync Summary",
    "totalCount": "{{total}} jobs",
    "tableAriaLabel": "Cross-tenant ingestion jobs",
    "loadError": "Could not load ingestion jobs."
  },
  "tenant": {
    "tab": {
      "overview": "Overview",
      "members": "Staff",
      "invitations": "Invitations",
      "ingestion": "Ingestion",
      "history": "Sync history",
      "wstudio": "WStudio Config",
      "contacts": "Contact mapping",
      "advanced": "Advanced",
      "settings": "Settings"
    }
  },
  "problems": {
    "jobFailures": "{{job}} — {{code}}, {{count}}× in 24h, last {{ago}} ago",
    "ghlWriteFailures": "{{count}} contacts failed to write to GoHighLevel on the last run.",
    "noData": "{{job}} — no records on the last run; worth a look.",
    "verification": "{{job}} — verification is not passing; re-run the dry run",
    "generic": "{{job}} — needs attention"
  },
  "runNow": {
    "button": "Run now",
    "enqueued": "{{service}} queued. It appears in the Queue within a few seconds.",
    "alreadyRunning": "{{service}} is already running.",
    "blockedTitle": "{{service}} cannot run:",
    "error": "Could not start {{service}}.",
    "queueLink": "Open the Queue",
    "blocked": {
      "GLOBAL_DISABLED": "Ingestion is globally disabled.",
      "TENANT_DISABLED": "This tenant is disabled.",
      "SERVICE_DISABLED": "This service is switched off.",
      "NOT_VERIFIED": "Run the dry-run tests first.",
      "NOT_SYNC_READY": "Waiting for history to finish loading.",
      "NOT_CONFIGURED": "WStudio credentials are not configured for this tenant.",
      "unknown": "This service cannot run right now."
    }
  },
  "tenantDetail": {
    "loadError": "Could not load tenant. Please try again.",
    "notFound": "Tenant not found",
    "notFoundBody": "The tenant '{{slug}}' could not be found.",
    "backToRoster": "Back to tenants",
    "opsLoadError": "Could not load operational settings.",
    "tabs": {
      "ariaLabel": "Tenant detail sections"
    },
    "overview": {
      "disabledTitle": "Disabled",
      "disabledGlobal": "Ingestion is off platform-wide",
      "disabledTenant": "This tenant is off",
      "disabledHint": "Change these on the Ingestion tab.",
      "problemsTitle": "Problems",
      "problemsNone": "No problems — failures and stale verification appear here.",
      "problemStale": "{{job}} — verification is stale, re-run the dry run",
      "problemFailed": "{{job}} — verification failed"
    },
    "settings": {
      "title": "Tenant WStudio settings",
      "formAriaLabel": "WStudio tenant settings form",
      "loadError": "Could not load WStudio settings.",
      "save": "Save WStudio settings",
      "saving": "Saving…",
      "saveSuccess": "WStudio settings saved.",
      "saveSuccessReverify": "Configuration changed — re-run the four dry-run tests to re-verify this tenant.",
      "saveError": "Could not save WStudio settings.",
      "domain": { "label": "Domain", "help": "Required WStudio tenant base URL." },
      "token": {
        "label": "WStudio API token",
        "set": "Set · {{suffix}}",
        "notSet": "Not set",
        "replace": "Replace",
        "replacement": "New token",
        "help": "Write-only. Blank preserves the stored token."
      },
      "studioId": { "label": "Studio ID", "help": "WStudio Studioid header value." },
      "reportUserId": {
        "label": "Report check-in user ID",
        "help": "User ID used to generate attendance reports."
      },
      "contacts": {
        "title": "Contact field mappings",
        "help": "Map open-ended contact.* keys to GHL field IDs.",
        "key": "Contact key",
        "value": "GHL field ID",
        "add": "Add mapping",
        "remove": "Remove",
        "catalogTitle": "Standard mappings",
        "catalogHelp": "Managed globally and applied to every tenant. The GoHighLevel field ID is resolved automatically.",
        "addedTitle": "Additional mappings",
        "addedHelp": "Pick a WStudio user attribute. The GoHighLevel field ID is discovered when you save.",
        "col": {
          "key": "Contact key",
          "attribute": "WStudio attribute",
          "fieldId": "GoHighLevel field ID",
          "status": "Status"
        },
        "attributeLabel": "WStudio user attribute",
        "fieldKeyLabel": "GoHighLevel field key",
        "status": {
          "resolved": "Resolved",
          "legacy": "Resolved by ID",
          "notFound": "Not found in GoHighLevel",
          "unknownAttribute": "Unknown attribute",
          "retired": "Retired",
          "retiredHelp": "Core-field mappings are no longer supported. This mapping is ignored — remove it."
        },
        "unresolvedWarning": "One or more required mappings could not be resolved. Create the matching custom field in GoHighLevel, then re-run the dry-run tests.",
        "attributesUnavailable": "The WStudio attribute list is unavailable, so new mappings cannot be added right now."
      },
      "advanced": {
        "title": "Advanced — override global config",
        "override": "Override",
        "overriding": "Overriding",
        "default": "Default",
        "revert": "Revert to default",
        "derived": "Derived value",
        "defaultValue": "default: {{value}}",
        "fullUrl": "Complete URL override",
        "urlHelp": "A URL override replaces the tenant domain and global path completely."
      },
      "validation": {
        "domain": "Domain is required.",
        "contact": "Enter a contact.<field> key and field ID for every mapping.",
        "duplicateContact": "Contact keys must be unique.",
        "attributeRequired": "Choose a WStudio user attribute for every mapping.",
        "fullUrl": "Enter a complete http(s) URL.",
        "nonNegativeInt": "Enter a whole number of 0 or more.",
        "nonNegativeNumber": "Enter an amount of 0 or more.",
        "valueThresholdOrder": "The mid-value threshold must be less than or equal to the high-value threshold.",
        "tenureOrder": "The established-tenure threshold must be less than or equal to the loyal-tenure threshold."
      },
      "membership": {
        "title": "Membership & classification",
        "help": "These settings are read together to classify members for marketing.",
        "valueHelp": "Both thresholds must be set for value classification to run. Leaving them blank is a valid choice — no value classification is produced.",
        "valuePartial": "Only one threshold is set, so value classification stays off."
      },
      "fields": {
        "WStudio_user_listWithFilters": "User list URL",
        "WStudio_user_listWithFilters_max": "User list maximum",
        "WStudio_user_listWithFilters_offset": "User list offset",
        "WStudio_user_listWithFilters_filter": "User list filter",
        "WStudio_sales_listSales": "Tenant sales URL",
        "WStudio_sales_listForUser": "Per-user sales URL",
        "WStudio_sales_listForUser_max": "Per-user sales maximum",
        "WStudio_sales_listForUser_offset": "Per-user sales offset",
        "WStudio_sales_listForUser_forceUpdate": "Force update",
        "WStudio_report_checkin": "Attendance report URL",
        "WStudio_product_listByType": "Product catalogue URL",
        "WStudio_product_listByType_max": "Product catalogue maximum",
        "WStudio_product_listByType_offset": "Product catalogue offset",
        "WStudio_product_types": "Product types to sync",
        "WStudio_membership_gracePeriodDays": "Grace period (days)",
        "WStudio_membership_shortTermThresholdDays": "Short-term threshold (days)",
        "WStudio_membership_renewalDueSoonDays": "Renewal due soon (days)",
        "WStudio_membership_tenureEstablishedDays": "Established tenure (days)",
        "WStudio_membership_tenureLoyalDays": "Loyal tenure (days)",
        "WStudio_membership_valueMidThreshold": "Mid-value threshold",
        "WStudio_membership_valueHighThreshold": "High-value threshold",
        "WStudio_genesis_syncReadyCoverageDays": "Attendance coverage required before sync (days)"
      }
    },
    "verification": {
      "allVerified": "WStudio verified",
      "notVerified": "WStudio not configured / not verified",
      "prompt": "Run all four dry-run tests to verify this tenant.",
      "verified": "Verified",
      "failed": "Failed",
      "notRun": "Not run",
      "stale": "Stale — re-run needed"
    },
    "header": {
      "dispatchState": "Dispatch state",
      "dispatchRunning": "Syncs are running",
      "dispatchUnknown": "Global status unknown",
      "blockedGlobal": "Blocked — global is off",
      "blockedTenant": "Blocked — tenant is off",
      "blockedServices": "Blocked — no services enabled",
      "lastSync": "Last sync",
      "statusLabel": "Tenant status: {{status}}",
      "leftRosterChip": "Left roster",
      "leftRosterAriaLabel": "This tenant has left the saas-auth roster",
      "leftRosterBody": "This tenant has left the saas-auth roster. It has been flagged but not deleted — existing data is preserved."
    },
    "actions": {
      "title": "Tenant actions",
      "tenantEnabled": "Tenant enabled",
      "enabledLabel": "Tenant enabled",
      "disabledLabel": "Tenant disabled",
      "tenantEnabledHelper": "When off, this tenant is skipped entirely — no syncs, no reports.",
      "enableSuccess": "Tenant enabled.",
      "disableSuccess": "Tenant disabled.",
      "enableError": "Could not update tenant status. Please try again.",
      "confirmEnableTitle": "Enable tenant?",
      "confirmEnableBody": "This will allow syncs to run for this tenant when the global and service switches are also on.",
      "confirmDisableTitle": "Disable tenant?",
      "confirmDisableBody": "This will prevent all syncs and reports for this tenant.",
      "statusActionsTitle": "Tenant status",
      "markActive": "Mark active",
      "suspendTenant": "Suspend tenant",
      "statusWriteUnavailable": "Status management is not yet available in this console. Use saas-admin to change tenant status.",
      "statusWriteHint": "Status is managed via saas-admin. A future console endpoint will enable direct status changes here."
    },
    "confirm": {
      "confirmButton": "Confirm",
      "cancelButton": "Cancel"
    },
    "gate": {
      "title": "Enable switches",
      "gateRule": "Gate rule:",
      "explainer": "A job runs only when global, tenant, and service are ALL on. If global or tenant is off, all services are paused even if their individual switches are on.",
      "globalLevel": "Global",
      "globalReadOnly": "Read-only here.",
      "globalLink": "Manage in Global Settings",
      "tenantLevel": "Tenant",
      "tenantHint": "Managed in Tenant actions above.",
      "serviceLevel": "Services",
      "gateOn": "On",
      "gateOff": "Off",
      "gateUnknown": "Unknown"
    },
    "services": {
      "enableSuccess": "{{service}} enabled.",
      "disableSuccess": "{{service}} disabled.",
      "enableError": "Could not update {{service}}."
    },
    "config": {
      "title": "Configuration",
      "formAriaLabel": "Tenant configuration form",
      "saveButton": "Save configuration",
      "saving": "Saving…",
      "resetButton": "Reset",
      "unsavedChanges": "Unsaved changes",
      "saveSuccess": "Configuration saved.",
      "saveError": "Could not save configuration. Please try again.",
      "validationError": "Validation failed. Check your input and try again.",
      "fieldRequired": "This field is required.",
      "freqMin1": "Frequency must be an integer ≥ 1.",
      "invalidTime": "Must be in HH:mm format (e.g. 00:30).",
      "invalidSendTimes": "Each time must be HH:mm format, comma-separated (e.g. 09:00,17:00).",
      "invalidDate": "Must be a valid date (YYYY-MM-DD).",
      "cooldownMin1": "Cooldown must be an integer ≥ 1.",
      "userSyncFrequency": "User sync frequency (hours)",
      "userSyncFrequencyHelper": "How often the WStudio→GHL user sync runs. Minimum 1.",
      "dailySyncTime": "Daily sync time (HH:mm)",
      "dailySyncTimeHelper": "When the daily previous-day pull runs, in app timezone.",
      "userSyncSendTimes": "User sync summary send times",
      "userSyncSendTimesPlaceholder": "e.g. 09:00,17:00",
      "userSyncSendTimesHelper": "Comma-separated HH:mm times for the daily digest email (app timezone). Leave empty for no scheduled report.",
      "backfillStartDate": "Backfill start date",
      "backfillStartDateHelper": "Genesis date for sales/attendance backfill (YYYY-MM-DD).",
      "backfillCooldown": "Backfill cooldown (minutes)",
      "backfillCooldownHelper": "Rest between weekly backfill chunks in minutes."
    },
    "dryRun": {
      "title": "Dry-run tests",
      "subtitle": "Validate before enabling — exercise the real fetch + parse for a date range but write nothing.",
      "salesTitle": "Sales dry-run",
      "attendanceTitle": "Attendance dry-run",
      "userTitle": "User dry-run",
      "ghlFieldsTitle": "GHL field check",
      "from": "From",
      "to": "To",
      "run": "Run test",
      "running": "Running…",
      "runError": "Dry-run request failed. Please try again.",
      "success": "Success",
      "failure": "Failed",
      "notConfigured": "Not configured",
      "warnings": "Warnings",
      "sampleData": "Sample data",
      "sampleRows": "{{n}} rows",
      "errorLabel": "Error:",
      "unknownError": "Unknown error",
      "writeNothing": "Dry-run only — no data is written, no watermarks are moved.",
      "table": {
        "title": "Sample records",
        "count": "Showing {{n}} of {{total}} fetched",
        "empty": "No records in this window.",
        "mapped": "mapped"
      },
      "match": {
        "create": "Create",
        "update": "Update",
        "noChange": "No change"
      },
      "counts": {
        "user": "{{n}} users fetched",
        "sales": "{{n}} records fetched (one page)",
        "attendance": "{{n}} rows parsed",
        "generic": "{{n}} records fetched",
        "salesHelp": "One page at the configured maximum — not the tenant's sales total, and not necessarily the most recent sales."
      },
      "plan": {
        "title": "Sync plan",
        "population": "{{wstudioUsers}} WStudio users · {{ghlContacts}} GoHighLevel contacts",
        "create": "{{n}} would be created",
        "update": "{{n}} would be updated",
        "noChange": "{{n}} already up to date",
        "unmatched": "{{n}} contacts with no WStudio match",
        "unmatchedHelp": "These are left untouched — the sync never deactivates or removes contacts.",
        "lastPurchaseFootnote": "Last-purchase changes are not checked, so the update count is a minimum.",
        "cappedWarning": "The WStudio user pull was capped — these counts cover only part of the population.",
        "allCreateWarning": "GoHighLevel holds {{ghlContacts}} contacts, yet all {{wstudioUsers}} WStudio users would be created rather than matched. The contact.wstudio_id mapping is pointing at the wrong GoHighLevel field, and a real sync would duplicate every contact. Verify the mapping before enabling sync."
      },
      "requestUrl": {
        "label": "WStudio request"
      },
      "attendance": {
        "title": "Report parse",
        "rowsInSheet": "{{n}} rows in the report",
        "parsed": "{{n}} parsed",
        "openGym": "{{n}} open-gym rows skipped",
        "incomplete": "{{n}} incomplete rows skipped",
        "emptyReport": "The report generated successfully but contained no rows for this window.",
        "incompleteWarning": "{{n}} of {{total}} rows arrived without a date, time or member. That usually means the attendance report's column layout has moved — check the report before trusting this sync."
      },
      "ghlFields": {
        "checked": "{{n}} mappings checked",
        "present": "{{n}} present",
        "missing": "{{n}} missing from GoHighLevel",
        "unresolved": "{{n}} never resolved",
        "matchKeyBroken": "contact.wstudio_id — the field used to match WStudio users to GoHighLevel contacts — is {{outcome}}. Until it is fixed, a real sync would match nothing and create a duplicate contact for every user on every run.",
        "repairHelp": "Missing fields must be created or renamed in GoHighLevel, then re-run this test. The console cannot create them."
      }
    },
    "syncWindow": {
      "title": "Sync window state",
      "syncWindow": "sync window",
      "inBackfill": "In backfill",
      "steadyState": "Steady state",
      "progress": "Backfill progress",
      "cursor": "Cursor",
      "lastWindow": "Last window",
      "never": "—",
      "loadError": "Could not load sync window state."
    },
    "jobs": {
      "title": "Ingestion jobs · this tenant",
      "tableAriaLabel": "Ingestion jobs for this tenant",
      "loadError": "Could not load job history."
    },
    "identity": {
      "loadError": "Could not load tenant identity.",
      "opsNotProvisioned": "Operational settings for this tenant aren't available yet — wsr-api hasn't mirrored it. It will appear on its next roster sync.",
      "status": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive",
        "SUSPENDED": "Suspended"
      }
    },
    "members": {
      "title": "Staff",
      "help": "Who can log into this tenant’s wsr-admin.",
      "tableAriaLabel": "Tenant staff",
      "col": {
        "email": "Email",
        "name": "Name",
        "role": "Role",
        "status": "Status",
        "actions": "Actions"
      },
      "role": {
        "OWNER": "Owner",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Staff",
        "USER": "User",
        "GUEST": "Guest"
      },
      "status": {
        "ACTIVE": "Active",
        "INVITED": "Invited",
        "DISABLED": "Disabled"
      },
      "loadError": "Could not load staff.",
      "empty": "No staff yet.",
      "changeRoleLabel": "Role for {{email}}",
      "changeRoleError": "Could not change role. Please try again.",
      "disableLabel": "Enabled",
      "toggleStatusError": "Could not update staff status. Please try again.",
      "removeButton": "Remove",
      "removeConfirmTitle": "Remove staff?",
      "removeConfirmBody": "This removes {{email}} from this tenant’s wsr-admin staff. Their account is not deleted.",
      "removeError": "Could not remove staff. Please try again.",
      "lastOwnerProtected": "This would remove the tenant's last owner.",
      "roleChangeCrossesTables": "This role change is not allowed for this staff member.",
      "addTitle": "Add staff",
      "addEmailLabel": "Email",
      "addEmailRequired": "Email is required.",
      "addRoleLabel": "Role",
      "addButton": "Add",
      "addSuccessMember": "Staff added.",
      "addSuccessInvitation": "Invite sent.",
      "addErrorAlreadyActive": "This person is already an active staff member.",
      "addErrorAlreadyPending": "An invitation is already pending for this email.",
      "addError": "Could not add staff. Please try again."
    },
    "invitations": {
      "title": "Invitations",
      "tableAriaLabel": "Tenant invitations",
      "col": {
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "created": "Created",
        "expires": "Expires",
        "actions": "Actions"
      },
      "statusAll": "Show all",
      "status": {
        "PENDING": "Pending",
        "ACCEPTED": "Accepted",
        "REVOKED": "Revoked",
        "EXPIRED": "Expired"
      },
      "loadError": "Could not load invitations.",
      "empty": "No pending invitations.",
      "emptyAll": "No invitations.",
      "resendButton": "Resend",
      "resendError": "Could not resend invitation. Please try again.",
      "revokeButton": "Revoke",
      "revokeConfirmTitle": "Revoke invitation?",
      "revokeConfirmBody": "This revokes the pending invitation to {{email}}. They will no longer be able to accept it.",
      "revokeError": "Could not revoke invitation. Please try again.",
      "alreadyAccepted": "This invitation was already accepted. The list has been refreshed.",
      "notFound": "This invitation could not be found. The list has been refreshed."
    }
  },
  "tenantQueue": {
    "title": "Queue",
    "empty": "Nothing running or scheduled."
  },
  "warehouse": {
    "title": "Warehouse",
    "members": "WStudio members",
    "sales": "Sales",
    "attendance": "Attendance",
    "products": "Products",
    "syncedAgo": "synced {{duration}} ago",
    "fullHistory": "full history",
    "backTo": "back to {{date}}"
  },
  "activity": {
    "title": "Activity",
    "ranAgo": "{{duration}} ago",
    "col": {
      "job": "Job",
      "kind": "Kind",
      "records": "Records",
      "ran": "Ran",
      "next": "Next"
    },
    "caughtUp": "Caught up",
    "counters": {
      "fetched": "{{n}} fetched",
      "landed": "{{n}} landed",
      "updated": "{{n}} updated",
      "unchanged": "{{n}} unchanged",
      "failed": "{{n}} failed",
      "ghlUpdates": "{{n}} GHL updates",
      "ghlInserts": "{{n}} GHL inserts",
      "ghlFailures": "{{n}} GHL failures",
      "ghlContactsRetrieved": "{{n}} GHL contacts retrieved",
      "labelRows": "{{n}} label rows",
      "categoryRows": "{{n}} category rows",
      "detailLines": "{{n}} detail lines",
      "duplicatesCollapsed": "{{n}} duplicates collapsed",
      "rowsInSheet": "{{n}} rows in sheet"
    },
    "kind": {
      "GENESIS": "genesis",
      "BACKFILL": "backfill",
      "LEADING_EDGE": "leading edge",
      "INCREMENTAL": "incremental"
    },
    "next": {
      "in": "in {{duration}}",
      "off": "off"
    }
  },
  "syncHistory": {
    "title": "Sync history",
    "emptyJobs": "No sync runs in the last 14 days.",
    "emptyJournalUserSync": "No per-user changes on this run.",
    "emptyJournalOtherType": "This job type has no per-row journal. Outcome and counts are on the run header.",
    "emptyJournalUnknown": "No per-row journal for this run.",
    "jobNotFound": "This run is no longer retained.",
    "backToList": "Back to list",
    "loadError": "Could not load sync history.",
    "journalTitle": "Journal",
    "jobTitle": "Job {{id}}",
    "filters": {
      "statusAria": "Filter by status",
      "allStatuses": "All statuses",
      "typeLabel": "Job type",
      "allTypes": "All types",
      "severityLabel": "Severity",
      "allSeverities": "All severities"
    },
    "col": {
      "id": "Id",
      "job": "Job",
      "status": "Status",
      "kind": "Kind",
      "finished": "Finished",
      "records": "Records",
      "when": "When",
      "severity": "Sev",
      "action": "Action",
      "entity": "Entity",
      "summary": "Summary"
    },
    "action": {
      "CREATED": "CREATED",
      "UPDATED": "UPDATED",
      "TAGGED": "TAGGED",
      "FAILED": "FAILED"
    },
    "entity": {
      "USER": "User",
      "GHL_CONTACT": "GoHighLevel contact"
    },
    "facts": {
      "show": "Show details",
      "hide": "Hide details"
    },
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "pageIndicator": "Page {{page}} of {{total}}"
  },
  "genesis": {
    "complete": "Complete",
    "loading": "Loading history",
    "notStarted": "Not started",
    "coveredFrom": "back to {{date}}",
    "coverageDays": "{{n}} days covered",
    "windowsRemaining": "{{n}} windows remaining"
  },
  "readiness": {
    "notConfigured": "WStudio is not configured for this tenant yet.",
    "notVerified": "Run the WStudio dry-run tests to verify this configuration. If the configuration changed recently, re-run them.",
    "readyToStart": "Verified and ready. Enable this tenant to start loading its history.",
    "blockedGlobal": "Ingestion is disabled platform-wide. Enable it under Tenants → Enable global ingestion.",
    "blockedTenant": "Verified and ready. Enable this tenant to start loading its history.",
    "blockedServices": "Verified and ready, but these services are off: {{services}}.",
    "genesisSales": "Loading sales history. This resolves on its own — no action needed.",
    "genesisAttendance": "Loading attendance history. This resolves on its own — no action needed.",
    "syncing": "Syncing to GoHighLevel. Older attendance history is still loading, so engagement signals are not available yet — this is normal."
  },
  "phase": {
    "notConfigured": "Not configured",
    "notVerified": "Not verified",
    "readyToStart": "Ready to start",
    "genesisSales": "Loading sales",
    "genesisAttendance": "Loading attendance",
    "syncing": "Syncing",
    "complete": "Complete"
  },
  "emailIdentity": {
    "title": "Email identity",
    "fromName": "From name",
    "fromAddress": "From address",
    "supportEmail": "Support address",
    "managedElsewhere": "Configured outside this console."
  },
  "reset": {
    "title": "Reset WStudio data",
    "description": "Permanently delete everything this tenant has downloaded from WStudio. This cannot be undone.",
    "button": "Reset WStudio data",
    "blocked": {
      "tenantEnabled": "Disable this tenant before resetting it.",
      "jobsInFlight": "Wait for running jobs to finish, then try again."
    },
    "willDelete": "This will permanently delete:",
    "showAllTables": "Show every table",
    "kept": "Kept: the tenant itself, its sync schedule and enable switches, report recipients, and the audit history.",
    "ghlNote": "GoHighLevel is not touched. Contacts, custom fields and tags written for these members stay in GoHighLevel and must be removed there.",
    "alsoDeleteConfig": "Also clear WStudio connection settings",
    "alsoDeleteConfigHelp": "You will need to re-enter the domain, token and Studio ID before this tenant can sync again.",
    "confirmLabel": "Type {{slug}} to confirm",
    "confirmButton": "Permanently delete",
    "successTitle": "Reset complete",
    "successNextSteps": "This tenant is now unverified and nothing will run. Run the dry-run tests, then enable it to begin loading history again.",
    "confirmMismatch": "The tenant name did not match.",
    "nothingDeleted": "Nothing was deleted."
  },
  "bootstrap": {
    "error": "Could not load application configuration.",
    "errorNotRegistered": "This host is not registered. Contact your administrator.",
    "retry": "Retry"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection and try again.",
    "rateLimited": "Too many requests. Please wait a moment and try again.",
    "insufficientPermissions": "You don't have permission for this action.",
    "platformAdminRequired": "Platform admin required.",
    "forbiddenTitle": "Insufficient permissions",
    "forbiddenBody": "You don't have permission to view this. A platform-admin credential is required.",
    "notFoundTitle": "Not found",
    "notFoundBody": "We couldn't find what you were looking for.",
    "codes": {
      "INVALID_RETURN_URL": "The return URL is not registered.",
      "SESSION_EXPIRED": "Your session has expired. Sign in again.",
      "CSRF_VALIDATION_FAILED": "Security check failed. Reload and try again.",
      "INVALID_CREDENTIALS": "Email or password is incorrect.",
      "PLATFORM_ADMIN_REQUIRED": "A platform-admin credential is required.",
      "TENANT_NOT_FOUND": "Tenant not found.",
      "TENANT_ORIGIN_MISMATCH": "Origin mismatch — not permitted for this tenant.",
      "RATE_LIMIT_REJECTED": "Too many requests. Please wait and try again.",
      "INVALID_LOCALE": "That language isn't supported.",
      "NETWORK_ERROR": "Network error. Check your connection and try again.",
      "UNKNOWN": "Something went wrong."
    }
  }
}
